module.exports = __webpack_public_path__ + "img/news.c1fed056.png";